import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 24,
  },
  paragraph: {
    marginBottom: theme.spacing(4.5),
  },
}));

export default useStyles;
